import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  footerOptions:any = [];
  isArabic: any;
  constructor(private storageService: StorageService) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.footerOptions = [{
      name: 'Media Centre',
      arabicName: 'المركز الاعلامي',
      link: '#'
    }, {
      name: 'Contact Us',
      arabicName: 'اتصل بنا',
      link: '#'
    }, {
      name: 'FAQ\'s',
      arabicName: 'التعليمات',
      link: '#'
    }, {
      name: 'Accessibility',
      arabicName: 'إمكانية الوصول',
      link: '#'
    }, {
      name: 'Terms of Use',
      arabicName: 'شروط الاستخدام',
      link: '#'
    }, {
      name: 'Disclaimer',
      arabicName: 'عدم اعطاء رأي',
      link: '#'
    }, {
      name: 'Customer Happiness Charter',
      arabicName: 'ميثاق إسعاد المتعاملين',
      link: '#'
    }, {
      name: 'Customer Happiness Equation',
      arabicName: 'معادلة إسعاد المتعاملين',
      link: '#'
    }, {
      name: 'Privacy Policy',
      arabicName: 'سياسة الخصوصية',
      link: '#'
    }, {
      name: 'Careers',
      arabicName: 'وظائف',
      link: '#'
    }, {
      name: 'Terminology',
      arabicName: 'المصطلح',
      link: '#'
    }]
  }

}
